import React from 'react';
import { Broadcast } from '../../../types';
import { Table } from 'components/shared/Table';
import { Box, Button } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { useHistory } from 'react-router-dom';
import { getBroadcastsTableColumns } from 'modules/broadcasts/lib';
import { useBroadcastsTableData } from 'modules/broadcasts/hooks/useBroadcastsTableData';
import { useSelector } from 'react-redux';
import { UserProfile } from 'types';
import { AdminRole } from '@trnsact/trnsact-shared-types';

export const BroadcastsTable = () => {
  const history = useHistory();

  const { loading, broadcasts } = useBroadcastsTableData();

  const userProfile = useSelector((state: any) => state.userProfile) as UserProfile;
  const isSuperAdmin = userProfile.adminRole === AdminRole.Super;

  const handleCreateBroadcast = () => {
    history.push('/dealers/broadcast/new');
  };

  const handleEditBroadcast = (broadcastId: string) => {
    history.push(`/dealers/broadcast/${broadcastId}`);
  };

  const broadcastsTableColumns = getBroadcastsTableColumns(isSuperAdmin, handleEditBroadcast);

  return (
    <Box>
      <CardContainer
        actionBtn={
          <Button variant="contained" size="small" startIcon={<AddCircleIcon />} onClick={handleCreateBroadcast}>
            Create Broadcast
          </Button>
        }
      >
        <Table<Broadcast>
          loading={loading}
          columns={broadcastsTableColumns}
          tableData={broadcasts}
          paginationOptions={{ pageSize: 10 }}
        />
      </CardContainer>
    </Box>
  );
};
